import React from 'react'
import './work.css'
import Images from '../../data/Images'

const Work = () => {
  return (
    <div className='work'>
        <div className="work-rec">
            <div className="cont-w">
                <div data-aos="fade-up" className="work-cont">
                    <img src={Images.Experience} alt="ex" />
                    <div className="w-title"><span>2+ Years</span>  <br/> Total Experience</div>
                </div>
                <div data-aos="fade-up" className="work-cont">
                    <img src={Images.Happy} alt="happy" />
                    <div className="w-title"><span>60+</span> <br/> Happy Clients</div>
                </div>
                <div data-aos="fade-up" className="work-cont">
                    <img src={Images.Laptop} alt="laptop" />
                    <div className="w-title"><span>80+</span> <br/> Projects Completed</div>
                </div>
                <div data-aos="fade-up" className="work-cont">
                    <img src={Images.People} alt="" />
                    <div className="w-title"><span>200+</span> <br/> People Reached </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Work